import React from "react";
import Modal from "react-bootstrap/Modal";
import { Row, Col, Button } from "react-bootstrap";
import { pageURLs } from "@/constants";
import { useNavigate } from "react-router-dom";

const NoWantAdFoundModal = (props) => {
  const navigate = useNavigate();
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-custom-width"
    >
      <Modal.Body className="pb-32">
        <h3 className="text-center mt-0">No such Want-Listing Found!</h3>

        <Row className="pt-32">
          <Col xl={12} className="">
            <div className="modal-btn-wrap">
              <Button
                variant="primary"
                className="btn w-100"
                onClick={() => navigate(pageURLs.wantad)}
              >
                Search Want-Listings
              </Button>
            </div>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};
export default NoWantAdFoundModal;
